import { PhotoContestAdsAppView } from '@smithsonian/js/ads/freestar/views/PhotoContestAdsAppView';
import $ from 'jquery';

freestar.queue.push(function () {
    new PhotoContestAdsAppView({});
});
